"use client";

import {
  ArrowDown,
  FlowDiagramFrame,
  FlowNode,
  HorizontalFlow,
} from "@/components/accounting/accounting-explainer-diagrams";

export function QuickBooksSyncFlowDiagram() {
  return (
    <FlowDiagramFrame
      title="How sync works"
      caption="One-way sync — accounting events in TA Desk are pushed to QuickBooks automatically."
    >
      <div className="flex min-w-[22rem] flex-col items-center gap-2 py-1">
        <FlowNode label="Booking transaction" sublabel="invoice, bill, or payment" tone="event" />
        <ArrowDown />
        <FlowNode label="TA Desk accounting" sublabel="journals & receipts" tone="neutral" />
        <ArrowDown />
        <div className="flex flex-wrap items-center justify-center gap-2">
          <FlowNode label="QuickBooks" sublabel="your company file" tone="bank" />
        </div>
        <div className="mt-2 flex flex-wrap justify-center gap-2">
          <FlowNode label="Invoices" tone="debit" className="min-w-[6.5rem]" />
          <FlowNode label="Bills" tone="credit" className="min-w-[6.5rem]" />
          <FlowNode label="Payments" tone="neutral" className="min-w-[6.5rem]" />
        </div>
      </div>
    </FlowDiagramFrame>
  );
}

export function StripePaymentFlowDiagram() {
  return (
    <FlowDiagramFrame
      title="Payment journey"
      caption="Customers pay via Stripe Checkout — TA Desk records the receipt automatically."
    >
      <HorizontalFlow
        steps={[
          { label: "Customer", sublabel: "quote or booking", tone: "event" },
          { label: "Stripe Checkout", sublabel: "secure payment page", tone: "bank" },
          { label: "Webhook", sublabel: "payment confirmed", tone: "neutral" },
          { label: "TA Desk", sublabel: "receipt created", tone: "debit" },
        ]}
      />
    </FlowDiagramFrame>
  );
}

export function StripeEmailPayFlowDiagram() {
  return (
    <FlowDiagramFrame title="Email pay buttons">
      <HorizontalFlow
        steps={[
          { label: "Reminder or confirmation email", tone: "event" },
          { label: "Pay now link", sublabel: "per brand", tone: "neutral" },
          { label: "Stripe Checkout", tone: "bank" },
        ]}
      />
    </FlowDiagramFrame>
  );
}
